export default __webpack_public_path__ + "static/products-header-girl-city-f3bd8e7df2d84e855915c177d22d223e.jpg";